// extracted by mini-css-extract-plugin
export var sliderRange = "_o6-2";
export var sliderRoot = "_o6-0";
export var sliderThumb = "_o6-3";
export var sliderTrack = "_o6-1";